import { appAxiosInstance } from '@/config/axios';

import { transformKeysSnakeToCamelCase } from '@/utils/transformation';

export type WorkspaceLocationsResponse = {
	locations: string[];
};

/**
 * Fetch all recently used locations across the workspace (page-level).
 * Returns the deduplicated union of all locations ever set on forms in this page.
 */
export const fetchWorkspaceLocations = async (
	pageId: string
): Promise<WorkspaceLocationsResponse> => {
	const response = await appAxiosInstance.post('/page/fetch-locations', { page_id: pageId });
	return transformKeysSnakeToCamelCase(response.data) as WorkspaceLocationsResponse;
};
